/**
 * LiveFlight Results Module
 * Handles flight search results and suggestions
 */

/**
 * Results state properties
 */
export const state = {
  results: [],
  suggestions: [],
  can_search_suggestions: true,
  /**
   * Raw by_time_window offers, cleared by initiate_search. A search by
   * suggestion restores them right after triggering the search, so the
   * dates stay visible.
   */
  date_suggestions: [],
  /**
   * One-shot filter: offer id to drop from the next search response.
   * results.vue applies it once and clears the slice. "" means inactive.
   */
  unset_flight_offer_id: "",
};

/**
 * Custom mutations for results state
 */
export const mutations = {
  // Update dictionaries in results
  dictionaries(state, data) {
    state.results.dictionaries = data;
  },

  // Reset search state (partial - only results-related)
  reset_results(state) {
    state.results = [];
  },

  unset_flight_offer_id(state, id) {
    state.unset_flight_offer_id = id || "";
  },
};

/**
 * Keys to persist in local storage
 * Note: Results are not persisted (too large and would be stale)
 */
export const localStorageKeys = [];
